/* eslint-disable no-lonely-if */
import React, { useState, useEffect } from 'react';
import ListCardsImage from '../../components/ListCardsImage';
import Feed from '../../components/Feed';
import CardHero from '../../components/CardHero';

const FeedContainer = ({
  feedProps,
  cardHeroProps,
  newsHighlight,
  newsFeedModularBlock,
  defaultRelatedNews
}) => {
  const [cards, setCards] = useState();
  const post = newsFeedModularBlock ? newsFeedModularBlock.post : [];

  useEffect(() => {
    if (post) {
      if (post.length > 0) { // At least 1 custom post
        if (newsHighlight) {
          const newCards = [newsHighlight, ...post];
          setCards(newCards);
        } else {
          setCards(post);
        }
      } else { // Mount the default related news
        if (newsHighlight) {
          const newCards = [newsHighlight, ...defaultRelatedNews];
          setCards(newCards);
        } else {
          setCards(defaultRelatedNews);
        }
      }
    }
  }, []);

  return (
    <Feed {...feedProps}>
      { newsHighlight && <CardHero {...cardHeroProps} /> }
      <ListCardsImage isFeed cards={cards} />
    </Feed>
  );
};

export default FeedContainer;
